<template>
  <transition name="modal">
  <ModalMediaViewer v-if="isBlocking" @close="close" sz="auto">
      <template v-slot:body>
        <div class="image-viewer-body">
          <ViewerTopBar :file="file" :showEditorFunc="showEditorFunc" :closer="close" />
          <div class="image-viewbox">
            <img :src="file.s3url" v-if="file && file.s3url" :alt="alt" crossOrigin="anonymous" />
          </div>
          <ViewerBottomBar :file="file" />
        </div>
      </template>
  </ModalMediaViewer>
  </transition>
</template>
<script>
import BaseComponent from '@/components/BaseComponent.vue'
import ModalMediaViewer from '@/components/controls/Viewers/ModalMediaViewer.vue'
import IconButton from '@/components/controls/IconButton.vue'
import ViewerTopBar from '@/components/controls/Viewers/ViewerTopBar.vue'
import ViewerBottomBar from '@/components/controls/Viewers/ViewerBottomBar.vue'

export default {
  name: 'image-viewer',
  extends: BaseComponent,
  components: { ModalMediaViewer, IconButton, ViewerTopBar, ViewerTopBar, ViewerBottomBar },
  props: ['file', 'showEditorFunc', 'closer'],
  data () {
    return {
      isBlocking: false,
      canvas: undefined
    }
  },
  computed: {
    alt () {
      if (this.file && this.file.filename) {
        return this.file.filename
      }
      return 'untitled image'
    }
  },
  methods: {
    show () {
      this.isBlocking = true
    },
    close () {
      this.isBlocking = false
      if (this.closer) {
        this.closer()
      }
    }
  }
}
</script>
<style scoped>
  .image-viewer-body {
    position: relative;
  }

  .image-viewbox {
    margin: 0 auto;
    text-align: center;
  }

  .image-viewbox img {
    border: 1px solid black;
    max-height: calc(100vh - 70px);
    max-width: calc(100vw - 10px);
    min-height: 250px;
    min-width: 250px;
    background-color: #333;
    border-radius: 5px;
  }
</style>